import React from 'react';
import { Tabs, Typography, Result } from 'antd';
import {
  AuditOutlined,
  RollbackOutlined,
} from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import { useModulePermission } from '../../hooks/usePermission';
import ApprovalTab from './components/ApprovalTab';
import WriteoffTab from './components/WriteoffTab';
import './BatchApprovalPage.css';

const { Title } = Typography;

// ============================================================
// Main Page
// ============================================================

const BatchApprovalPage: React.FC = () => {
  const permissions = useModulePermission('batch_approval');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'approval';
  const acceptanceFormId = searchParams.get('acceptanceForm') || undefined;

  const handleTabChange = (key: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', key);
    setSearchParams(next, { replace: true });
  };

  const tabItems = [
    {
      key: 'approval',
      label: (
        <span>
          <AuditOutlined />
          待核准
        </span>
      ),
      children: <ApprovalTab acceptanceFormId={acceptanceFormId} />,
    },
    {
      key: 'writeoff',
      label: (
        <span>
          <RollbackOutlined />
          待沖銷
        </span>
      ),
      children: <WriteoffTab />,
    },
  ];

  if (!permissions.canView) {
    return (
      <Result
        status="403"
        title="無權限"
        subTitle="您沒有批次審核的查看權限，請聯繫管理員。"
      />
    );
  }

  return (
    <div className="batch-approval-container">
      <Title level={4} style={{ marginBottom: 16 }}>
        批次審核 / 沖銷
      </Title>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabItems}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default BatchApprovalPage;
